import { BodyComponent } from '@darshanpatel2608/human-body-react';
import { Card, Divider } from 'antd';
import React, { useState } from 'react';
// import { BodyComponent } from '../BodyComponent/BodyComponent';

const ImageMapBody = ({selectedParts,setSelectedParts,t}) => {
    // const [selectedParts, setSelectedParts] = useState([]);
    // console.log(selectedParts, "selectedParts");
    const handlePartClick = (part) => {
        console.log(part, "part");
        if (selectedParts?.includes(part)) {
            setSelectedParts(selectedParts?.filter(p => p !== part));
        } else {
            setSelectedParts([...selectedParts, part]);
        }
    };
    return (
        <Card
            style={{
                background: "#00000078",
                margin: "20px 0",
            }}
        >
            {/* <Divider orientation="left">{t.bodyMap}</Divider> */}
            <BodyComponent
                partsInput={{
                    head: { show: true,selected: selectedParts?.includes('head')},
                    left_shoulder: { show: true, selected: selectedParts?.includes('left_shoulder') },
                    right_shoulder: { show: true, selected: selectedParts?.includes('right_shoulder') },
                    left_arm: { show: true, selected: selectedParts?.includes('left_arm') },
                    right_arm: { show: true, selected: selectedParts?.includes('right_arm') },
                    chest: { show: true, selected: selectedParts?.includes('chest') },
                    stomach: { show: true, selected: selectedParts?.includes('stomach') },
                    left_leg: { show: true, selected: selectedParts?.includes('left_leg') },
                    right_leg: { show: true, selected: selectedParts?.includes('right_leg') },
                    left_hand: { show: true, selected: selectedParts?.includes('left_hand') },
                    right_hand: { show: true, selected: selectedParts?.includes('right_hand') },
                    left_foot: { show: true, selected: selectedParts?.includes('left_foot') },
                    right_foot: { show: true, selected: selectedParts?.includes('right_foot') },
                }}
                selectedParts={selectedParts}
                onClick={(part) => handlePartClick(part)}
            />
        </Card>
    );
};

export default ImageMapBody;
